import { defineComponent as _defineComponent } from 'vue'
import BCXForm from '@/components/molecules/forms/BCXForm.vue';
import { computed } from 'vue';
import { BcxFormField } from '@/models/BcxForm';
import useI18n from '@/mixins/useI18n';
import BCXUserBanner from '@/components/molecules/BCXUserBanner.vue';
import XIcon from '@/components/svg/x-circle-2.svg?inline';
import useMeetingScheduler from '@/components/meeting-scheduler/composables/useMeetingScheduler';
import { ConflictEntry, PayloadTimeSlot, TimeSlotDetail } from '@/models/MeetingScheduler';
import MeetingSlotConflict from '@/components/meeting-scheduler/components/MeetingSlotConflict.vue';
import BCXMessengerUserSelect from '@/components/messenger/User/BCXMessengerUserSelect.vue';
import { User } from '@/models/User';
import useFormattedDateTime from '@/mixins/useFormattedDateTime';
import MeetingCaption from '@/components/meeting-scheduler/components/MeetingCaption.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingForm',
  setup(__props) {

const { t } = useI18n();
const { getFormattedTimeRange, getFormattedDate } = useFormattedDateTime();

const { form, appointmentsByMonth, isParticipantPreset } = useMeetingScheduler();

function onSelectUser(newUser: User) {
  if (newUser.userId) form.value.participantId = newUser.userId;
}

const fields = computed<BcxFormField[]>(() => [
  {
    name: 'subject',
    width: '100%',
    label: t('meeting.form.form.topic'),
    type: 'textarea',
    textareaOptions: { height: 64, enlargedHeight: 150, maxLength: 250 }
  },
  {
    name: 'location',
    width: '100%',
    label: t('meeting.form.form.location'),
    type: 'textarea',
    textareaOptions: { height: 64, enlargedHeight: 150, maxLength: 250 }
  }
]);

function onDeleteSuggestion(slot: PayloadTimeSlot) {
  form.value.timeSlots = form.value.timeSlots.filter((s) => s.start !== slot.start || s.end !== slot.end);
}

const suggestions = computed<TimeSlotDetail[]>(() => {
  const knownAppointments = Object.values(appointmentsByMonth.value).flat();

  return form.value.timeSlots.map((slot) => {
    const slotStart = new Date(slot.start).getTime();
    const slotEnd = new Date(slot.end).getTime();
    const conflictIds = new Set<string>();
    knownAppointments.forEach((meeting) => {
      if (slotStart < new Date(meeting.end).getTime()
        && new Date(meeting.start).getTime() < slotEnd) {
        conflictIds.add(meeting.meetingId);
      }
    });
    const conflicts: ConflictEntry[] = [...conflictIds].map((meetingId) => ({ meetingId }));
    return {
      timeSlotId: `${slot.start}_${slot.end}`, start: slot.start, end: slot.end, conflicts
    };
  });
});

function enforceDeadlineRange() {
  const DEADLINE_MIN = 1;
  const DEADLINE_MAX = 30;

  const num = Number(form.value.deadlineInDays);
  form.value.deadlineInDays = Number.isNaN(num) ? DEADLINE_MIN : Math.min(DEADLINE_MAX, Math.max(DEADLINE_MIN, num));
}

return { __sfc: true,t, getFormattedTimeRange, getFormattedDate, form, appointmentsByMonth, isParticipantPreset, onSelectUser, fields, onDeleteSuggestion, suggestions, enforceDeadlineRange, BCXForm, BCXUserBanner, XIcon, MeetingSlotConflict, BCXMessengerUserSelect, MeetingCaption }
}

})